import PropTypes from 'prop-types';

function Nav({ t, pathData }) {
  return (
    <ul className={`absolute left-1/2 -translate-x-1/2 flex items-center gap-8 max-[650px]:hidden ${pathData.url === '/login' ? 'opacity-30' : ''}`}>
      <li>
        <a
          id="link-guide"
          className="relative font-bold after:absolute after:bottom-[-2px] after:left-1/2 after:right-1/2 after:h-0.5 after:bg-white after:transition-all hover:after:left-0 hover:after:right-0"
          target="_blank"
          rel="noopener noreferrer"
          href={t('link.guideUrl')}
        >
          {t('link.guide')}
        </a>
      </li>
      <li>
        <a
          id="link-upadteNote"
          className="relative font-bold after:absolute after:bottom-[-2px] after:left-1/2 after:right-1/2 after:h-0.5 after:bg-white after:transition-all hover:after:left-0 hover:after:right-0"
          target="_blank"
          rel="noopener noreferrer"
          href={t('link.updateNoteUrl')}
        >
          {t('link.updateNote')}
        </a>
      </li>
    </ul>
  );
}

Nav.propTypes = {
  t: PropTypes.func.isRequired,
  pathData: PropTypes.shape({
    url: PropTypes.string,
  }).isRequired,
};

export default Nav;
